import { LiuHe } from "./ganZhi";
export const YueJiangName = {
    "亥": "登明",
    "戌": "河魁",
    "酉": "从魁",
    "申": "传送",
    "未": "小吉",
    "午": "胜光",
    "巳": "太乙",
    "辰": "天罡",
    "卯": "太冲",
    "寅": "功曹",
    "丑": "大吉",
    "子": "神后",
}
// 月将即月令的六合位
export const YueJiang = {
    "雨水": "亥",
    "惊蛰": "亥",
    "春分": "戌",
    "清明": "戌",
    "谷雨": "酉",
    "立夏": "酉",
    "小满": "申",
    "芒种": "申",
    "夏至": "未",
    "小暑": "未",
    "大暑": "午",
    "立秋": "午",
    "处暑": "巳",
    "白露": "巳",
    "秋分": "辰",
    "寒露": "辰",
    "霜降": "卯",
    "立冬": "卯",
    "小雪": "寅",
    "大雪": "寅",
    "冬至": "丑",
    "小寒": "丑",
    "大寒": "子",
    "立春": "子"
}